
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[tenantAlias]",
      function () {
        return require("private-next-pages/[tenantAlias]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[tenantAlias]"])
      });
    }
  